// extracted by mini-css-extract-plugin
export default {"AudioEditingSectionContainer":"AudioEditingSection_AudioEditingSectionContainer__6Pqmd"};